import { render } from "./Results2.vue?vue&type=template&id=26cabbb8&scoped=true"
import script from "./Results2.vue?vue&type=script&lang=js"
export * from "./Results2.vue?vue&type=script&lang=js"

import "./Results2.vue?vue&type=style&index=0&id=26cabbb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cabbb8"]])

export default __exports__